import type { showAddressBookMutator } from "./lazyIndex";
import { createLazyComponent, LazyAction, type LazyComponent } from "owa-bundling";
import { lazyModule } from "./lazyModule";
import { getAddressBookStore } from "./store/addressBookStore";

// Keep this entry independent of recipient-picker stores and localization.
export const lazyShowAddressBook: LazyAction<typeof showAddressBookMutator, typeof lazyModule> = new LazyAction(lazyModule, m => m.showAddressBookMutator);

export const LazyAddressBook: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.AddressBook, undefined /* placeholder */, undefined /* importErrorHandler */, { onlyImportIf: () => !!getAddressBookStore().mailboxInfo });
